export default "__VITE_ASSET__CAuQSBo9__"